import React from 'react';

import CloseButton from '@/components/CloseButton/CloseButton';
import ConnectionFinishedContent from '@/containers/ConnectionPages/ConnectionPage/components/ConnectionFinished/ConnectionFinishedContent';
import ConnectionPageContent from '@/containers/ConnectionPages/ConnectionPage/components/ConnectionInProgress/ConnectionPageContent';
import useConnectionPage from '@/containers/ConnectionPages/ConnectionPage/hooks/useConnectionPage';

const QuickStartGuideConnectionContent = ({onClose, deviceType}) => {
    const {currentStep, steps, isConnectionFinished} = useConnectionPage();

    return (
        <div className='relative flex h-full w-[308px] shrink-0 flex-col items-center justify-center bg-romance p-8'>
            <CloseButton onClick={onClose} className='absolute left-5 top-5' />
            {isConnectionFinished ? (
                <>
                    <ConnectionFinishedContent className='gap-8' />
                    <ConnectionFinishedContent.PersonalizeButton primary className='mt-8' />
                </>
            ) : (
                <>
                    <ConnectionPageContent.Icon />
                    <ConnectionPageContent.Header currentStep={currentStep} className='mt-8' deviceType={deviceType} />
                    <ConnectionPageContent.ConnectionProgress
                        steps={steps}
                        currentStep={currentStep}
                        className='mt-8'
                        progressBarClassName='ml:bg-primary-dark-5'
                    />
                    <ConnectionPageContent.Description
                        className='mt-8'
                        currentStep={currentStep}
                        deviceType={deviceType}
                    />
                </>
            )}
        </div>
    );
};

export default QuickStartGuideConnectionContent;
